module.exports = __webpack_public_path__ + "static/media/whisky_distillery_desktop.36a33daa.jpg";